const PropTypes = require('prop-types');
const React = require('react');

// @ commons
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');

const TruncateText = props => {
    const { str, charLimit, lineAmount, lineFeed, isHtml } = props;

    if (isHtml) {
        const totalCharLimit = charLimit * lineAmount;
        const shortStr = str.substring(0, totalCharLimit);
        const tags = shortStr.match(/<.+?>/g) || [];
        const tagsLength = tags.join('').length;
        const strLimit = totalCharLimit + tagsLength;

        const resultSummary = str.slice(0, strLimit).concat('...');

        return <HTMLSafeInjector message={resultSummary} />;
    }

    const linesLimitIndex = lineAmount - 1;
    const words = str.split(' ');
    let lines = [];
    let line = '';
    if (str.length < charLimit) {
        //Is just a one line string
        lines.push(str);
    } else {
        words.forEach((word, index) => {
            if (line.length + word.length + 1 < charLimit) {
                line = index === 0 ? `${word}` : `${line} ${word}`;
            } else {
                lines.push(line);
                line = word;
            }
        });
    }

    // Second conditional, only append ellipsis if the number of lines is more than the limit.
    if (lines[linesLimitIndex] && lines.length > lineAmount) {
        lines[linesLimitIndex] = ` ${lines[linesLimitIndex].slice(0, -3)}`;
        lines[linesLimitIndex] = ` ${lines[linesLimitIndex]}...`;
    }

    if (lines[linesLimitIndex]) {
        lines[linesLimitIndex] = ` ${lines[linesLimitIndex].slice(0, -3)}`;
        lines[linesLimitIndex] = ` ${lines[linesLimitIndex]}...`;
    }

    const elements = lines.map((line, index) => {
        if (index <= linesLimitIndex) {
            // We check if the stored message has HTML tags.
            if (/<[a-z][\s\S]*>/i.test(line)) {
                if (lineFeed) {
                    return <HTMLSafeInjector key={index} message={line} />;
                } else {
                    return <HTMLSafeInjector inline key={index} message={line} />;
                }
            } else {
                if (lineFeed) {
                    return (
                        <span style={{ display: 'block' }} key={index}>
                            {line}
                        </span>
                    );
                } else {
                    return (
                        <span key={index}>
                            {line}
                        </span>
                    );
                }
            }
        }
    });

    return (
        <span style={{ display: 'block' }}>
            {elements}
        </span>
    );
};

TruncateText.defaultProps = {
    lineFeed: true,
    isHtml: false
};

TruncateText.propTypes = {
    str: PropTypes.string,
    charLimit: PropTypes.number,
    lineAmount: PropTypes.number,
    lineFeed: PropTypes.bool,
    isHtml: PropTypes.bool
};

module.exports = TruncateText;